import { render, staticRenderFns } from "./SearchTabAlert.vue?vue&type=template&id=8a0475a4&"
import script from "./SearchTabAlert.vue?vue&type=script&lang=ts&"
export * from "./SearchTabAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTabAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SearchTabAlert.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
